import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row col-md-7" }
const _hoisted_2 = { class: "el-input-group" }
const _hoisted_3 = { class: "col-md-9" }
const _hoisted_4 = { class: "input-group" }
const _hoisted_5 = { class: "row col-md-7" }
const _hoisted_6 = { class: "el-input-group" }
const _hoisted_7 = { class: "col-md-9" }
const _hoisted_8 = { class: "input-group" }
const _hoisted_9 = { class: "row col-md-7" }
const _hoisted_10 = { class: "el-input-group" }
const _hoisted_11 = { class: "col-md-9" }
const _hoisted_12 = { class: "input-group" }
const _hoisted_13 = { class: "row col-md-7" }
const _hoisted_14 = { class: "el-input-group" }
const _hoisted_15 = { class: "col-md-9" }
const _hoisted_16 = { class: "input-group" }
const _hoisted_17 = { class: "row col-md-7" }
const _hoisted_18 = { class: "el-input-group" }
const _hoisted_19 = { class: "col-md-9" }
const _hoisted_20 = { class: "input-group" }
const _hoisted_21 = { class: "row col-md-7" }
const _hoisted_22 = { class: "el-input-group" }
const _hoisted_23 = { class: "col-md-9" }
const _hoisted_24 = { class: "input-group" }
const _hoisted_25 = { class: "row col-md-7" }
const _hoisted_26 = { class: "el-input-group" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = { class: "page-content-info d-flex align-items-center justify-content-end" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-md-2" }
const _hoisted_32 = {
  key: 0,
  class: "col-md-2"
}
const _hoisted_33 = {
  key: 1,
  class: "col-md-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_multiselect = _resolveComponent("multiselect")!
  const _component_DeleteReasonDialog = _resolveComponent("DeleteReasonDialog")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[16] || (_cache[16] = _createElementVNode("h2", null, "Общий табель по ДО", -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[10] || (_cache[10] = _createElementVNode("label", {
          for: "bin",
          class: "form-label col-md-3"
        }, "БИН", -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              id: "bin",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchParams.bin) = $event))
            }, null, 512), [
              [_vModelText, _ctx.searchParams.bin]
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _cache[11] || (_cache[11] = _createElementVNode("label", {
          for: "lmsId",
          class: "form-label col-md-3"
        }, "LMS ID", -1)),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              id: "lmsId",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchParams.lmsId) = $event))
            }, null, 512), [
              [_vModelText, _ctx.searchParams.lmsId]
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _cache[12] || (_cache[12] = _createElementVNode("label", {
          for: "lmsId",
          class: "form-label col-md-3"
        }, "Название ДО", -1)),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              id: "kindergartenName",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchParams.kindergartenName) = $event))
            }, null, 512), [
              [_vModelText, _ctx.searchParams.kindergartenName]
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _cache[13] || (_cache[13] = _createElementVNode("label", {
          for: "accountingMonth",
          class: "form-label col-md-3"
        }, "Расчетный месяц", -1)),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _withDirectives(_createElementVNode("input", {
              type: "number",
              max: "12",
              class: "form-control",
              id: "accountingMonth",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchParams.accountingMonth) = $event))
            }, null, 512), [
              [_vModelText, _ctx.searchParams.accountingMonth]
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _cache[14] || (_cache[14] = _createElementVNode("label", {
          for: "accountingYear",
          class: "form-label col-md-3"
        }, "Расчетный год", -1)),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _withDirectives(_createElementVNode("input", {
              type: "number",
              min: "2024",
              class: "form-control",
              id: "accountingYear",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchParams.accountingYear) = $event))
            }, null, 512), [
              [_vModelText, _ctx.searchParams.accountingYear]
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _cache[15] || (_cache[15] = _createElementVNode("label", {
          for: "kato",
          class: "form-label col-md-3"
        }, "Населенный пункт", -1)),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_multiselect, {
              modelValue: _ctx.kato,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.kato) = $event)),
              options: _ctx.katoList,
              searchable: true,
              closeOnSelect: true,
              "track-by": "code",
              "custom-label": _ctx.formattedKatoLabel,
              placeholder: "Выберите Като",
              multiple: false,
              "clear-on-select": true
            }, null, 8, ["modelValue", "options", "custom-label"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("button", {
          class: "btn btn-primary",
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.fetchTimesheetData && _ctx.fetchTimesheetData(...args))),
          disabled: _ctx.fetchLoading
        }, _toDisplayString(!_ctx.fetchLoading ? "Поиск" : "Загрузка..."), 9, _hoisted_27)
      ])
    ]),
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("button", {
        disabled: (_ctx.timesheetGeneralResponse.length === 0),
        class: "btn btn-info",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.downloadGeneratedCalculationReportList()))
      }, "Выгрузить результат по фильтру ", 8, _hoisted_29)
    ]),
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("span", null, "Элементов: " + _toDisplayString(_ctx.timesheetGeneralResponse.length), 1)
      ]),
      (_ctx.hasAccess(_ctx.adminRoles))
        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
            _createElementVNode("span", null, "Выбрано: " + _toDisplayString(_ctx.selectionTimesheetDataList.length), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.hasAccess(_ctx.adminRoles))
        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
            (_ctx.selectionTimesheetDataList.length > 0)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-danger",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showDeleteConfirmationModal = true))
                }, "Удалить выбранные элементы (" + _toDisplayString(_ctx.selectionTimesheetDataList.length) + ") ", 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_DeleteReasonDialog, {
      modelValue: _ctx.showDeleteConfirmationModal,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.showDeleteConfirmationModal) = $event)),
      title: "Вы точно хотите удалить выбранные строки из табеля?",
      loading: _ctx.fetchLoading,
      onConfirm: _ctx.handleDeleteSelectedElements
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", null, "Выбрано строк: " + _toDisplayString(_ctx.selectionTimesheetDataList.length) + ". После удаления табель будет пересчитан.", 1)
      ]),
      _: 1
    }, 8, ["modelValue", "loading", "onConfirm"]),
    _createVNode(_component_el_table, {
      ref: "multipleTableRef",
      onSelectionChange: _ctx.handleSelectionChange,
      data: _ctx.timesheetGeneralResponse,
      style: {"width":"100%"},
      border: "",
      height: "95vh"
    }, {
      default: _withCtx(() => [
        (_ctx.hasAccess(_ctx.adminRoles))
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              type: "selection"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          type: "index",
          label: "#"
        }),
        _createVNode(_component_el_table_column, {
          prop: "accountingMonth",
          label: "Расчетный месяц"
        }),
        _createVNode(_component_el_table_column, {
          prop: "accountingYear",
          label: "Расчетный год"
        }),
        _createVNode(_component_el_table_column, {
          prop: "bin",
          label: "БИН ДО"
        }),
        _createVNode(_component_el_table_column, {
          prop: "lmsId",
          label: "LMS ID"
        }),
        _createVNode(_component_el_table_column, {
          prop: "kindergartenName",
          label: "Наименование ДО"
        }),
        _createVNode(_component_el_table_column, {
          prop: "lmsName",
          label: "Наименование LMS системы"
        }),
        _createVNode(_component_el_table_column, {
          prop: "totalDaysInMonth",
          label: "Общее количество дней в месяце"
        }),
        _createVNode(_component_el_table_column, {
          prop: "workingDays",
          label: "Рабочие дни в месяце"
        }),
        _createVNode(_component_el_table_column, {
          prop: "weekendDays",
          label: "Выходные и праздничные дни в месяце"
        }),
        _createVNode(_component_el_table_column, {
          prop: "excusedAbsenceDays",
          label: "Отсутствие по уважительной причине"
        }),
        _createVNode(_component_el_table_column, {
          prop: "unexcusedAbsenceDays",
          label: "Отсутствие по неуважительной причине"
        }),
        _createVNode(_component_el_table_column, {
          prop: "presenceDays",
          label: "Дни присутствия"
        }),
        _createVNode(_component_el_table_column, {
          prop: "sickLeaveDays",
          label: "Больничный"
        }),
        _createVNode(_component_el_table_column, {
          prop: "vacationDays",
          label: "Отпуск"
        }),
        _createVNode(_component_el_table_column, {
          prop: "planningDays",
          label: "Прогноз оплачиваемых дней"
        }),
        _createVNode(_component_el_table_column, {
          prop: "totalVisitDays",
          label: "Всего посещений"
        }),
        _createVNode(_component_el_table_column, {
          prop: "recalculationAmount",
          label: "Перерасчет"
        }),
        _createVNode(_component_el_table_column, {
          prop: "retentionAmount",
          label: "Корректировка"
        }),
        _createVNode(_component_el_table_column, {
          prop: "plannedToAccrue",
          label: "Планируется к начислению"
        }),
        _createVNode(_component_el_table_column, {
          prop: "totalToAccrue",
          label: "Итого к начислению"
        }),
        _createVNode(_component_el_table_column, {
          prop: "actuallyPaidAmount",
          label: "Фактически оплачено"
        }),
        _createVNode(_component_el_table_column, {
          prop: "sendDate",
          label: "Дата и время отправки"
        })
      ]),
      _: 1
    }, 8, ["onSelectionChange", "data"])
  ]))
}